import * as React from "react";
import type { SVGProps } from "react";
const SvgRefresh01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6 19.2a3.6 3.6 0 0 1-3.6-3.6V8.4A3.6 3.6 0 0 1 6 4.8h5.4m4.8 0H18a3.6 3.6 0 0 1 3.6 3.6v7.2a3.6 3.6 0 0 1-3.6 3.6h-7.8m0 0 2.4-2.4m-2.4 2.4 2.4 2.4M10.2 7.2l2.4-2.4-2.4-2.4"
    />
  </svg>
);
export default SvgRefresh01;
